// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1O25d","footer":"ModalError_footer__19qA5"};